export interface SentryUserMeta {
  id?: string;
  email?: string;
  name?: string;
  orgId?: string;
}

export const SENTRY_USER_META_KEY = "sentry_user_meta";

export const readSentryUserMeta = (): SentryUserMeta => {
  try {
    const raw = localStorage.getItem(SENTRY_USER_META_KEY);
    if (!raw) return {};
    return (JSON.parse(raw) as SentryUserMeta) ?? {};
  } catch {
    return {};
  }
};

export const writeSentryUserMeta = (meta: SentryUserMeta): void => {
  localStorage.setItem(SENTRY_USER_META_KEY, JSON.stringify(meta));
};

export const clearSentryUserMeta = (): void => {
  localStorage.removeItem(SENTRY_USER_META_KEY);
};
